import { defaultStateValue } from "../../utils/helper";

const initialState = {
  base64Images: [],
  allCsvData: [],
  clientName: "",
  reportName: "COMPARATIVE MARKET ANALYSIS",
  csvNewData: {
    added_COMPARABLESLIST: {
      Current_State: "",
      Sold_Date: "",
      ofchange: "",
      Sold_Price: "",
    },
    Levels: "",
    "Year Built": "",
    "Lot Size": "",
    "Above Grade Square Feet": "",
    "Basement Square Feet": "",
    "Finished Square Feet": "",
    "Total Square Feet": "",
    "Heating/Cooling": "",
    Fireplace: "",
    Bedrooms: "",
    Bathrooms: "",
    Garage: "",
    "Garage Spaces": "",
    "Garage Type": "",
    "Public-Remarks": "",
    properties_address: "",
    add_adjustment: true,
    notes: "",
    uuid: "",

    propertyImages: [],
    selectedAdditionalInfo: [],
    checked: [],
    additionalHomeFacts: {},
  },
  options: [
    { value: "One", label: "One" },
    { value: "Two", label: "Two" },
    { value: "Three Or More", label: "Three Or More" },
    { value: "Bi-Level", label: "Bi-Level" },
    { value: "Tri-Level", label: "Tri-Level" },
    { value: "Multi/Split", label: "Multi/Split" },
  ],
  formula_Division_DefaultValue: "",
  listing_id_arr: [],
  address: "",
  selectedPropertydataUUID: "",
  selectedPropertyAddress: "",
  comaparables: [],
  selectPropertyList: [],
  selectedAdditionalInfo: [],
  selectedPropertydata: [
    {
      Levels: "",
      "Year Built": "",
      "Lot Size": "",
      "Above Grade Square Feet": "",
      "Basement Square Feet": "",
      "Finished Square Feet": "",
      "Total Square Feet": "",
      "Heating/Cooling": "",
      Fireplace: "",
      Bedrooms: "",
      Bathrooms: "",
      Garage: "",
      "Garage Spaces": "",
      "Garage Type": "",
      properties_address: "",
      propertyImages: [],
      selectedAdditionalInfo: [],
      additionalHomeFacts: {},
    },
  ],
  range: { start: "", end: "" },
  adjustment_formulas: [],
  review_data: {},
  report_data: [],
  defaultFormulaState: defaultStateValue,
  changeDefaultValues: {},
  userAddedDefaultValues: "",
  count: 0,
  inputAddressState: false,
  businessImages: [],
  isUploadCSV: true,
  extracomparable: [],
  comarablePropertyuuid: "",
  color: "#0070c0",
  csvType: { value: "ReColorado", label: "ReColorado" },
  removedComparableList: [],
  newComparableUpload: [],
  newCSVComparableUpload: []
};

const UserReduser = (state = initialState, action) => {
  switch (action.type) {
    case "csvNewData":
      return {
        ...state,
        csvNewData: action.payload,
      };
    case "changeDefaultValues":
      return {
        ...state,
        changeDefaultValues: action.payload,
      };
    case "userAddedDefaultValues":
      return {
        ...state,
        userAddedDefaultValues: action.payload,
      };
    case "count":
      return {
        ...state,
        count: action.payload,
      };
    case "reviewData":
      return {
        ...state,
        review_data: action.payload,
      };
    case "formula_Division_DefaultValue":
      return {
        ...state,
        formula_Division_DefaultValue: action.payload,
      };
    case "reportData":
      return {
        ...state,
        report_data: action.payload,
      };

    case "selectedPropertydata":
      return {
        ...state,
        selectedPropertydata: action.payload,
      };
    case "selectedPropertydataUUID":
      return {
        ...state,
        selectedPropertydataUUID: action.payload,
      };
    case "selectedPropertyAddress":
      return {
        ...state,
        selectedPropertyAddress: action.payload,
      };
    case "clientName":
      return {
        ...state,
        clientName: action.payload,
      };
    case "ReportName":
      return {
        ...state,
        reportName: action.payload,
      };
    case "Address":
      return {
        ...state,
        address: action.payload,
      };

    case "allCsvData":
      return {
        ...state,
        allCsvData: action.payload,
      };
    case "selectedAdditionalInfo":
      return {
        ...state,
        selectedAdditionalInfo: action.payload,
      };
    case "PropertyImages":
      return {
        ...state,
        propertyImages: action.payload,
      };
    case "uuid":
      return {
        ...state,
        uuid: action.payload,
      };
    case "comaparableData":
      return {
        ...state,
        comaparables: action.payload,
      };
    case "PageChecked":
      return {
        ...state,
        checked: action.payload,
      };
    case "selectPropertyList":
      return {
        ...state,
        selectPropertyList: action.payload,
      };
    case "propertyPriceRange":
      return {
        ...state,
        range: action.payload,
      };

    case "adjustmentFormulas":
      return {
        ...state,
        adjustment_formulas: action.payload,
      };
    case "ListArray":
      return {
        ...state,
        listing_id_arr: action.payload,
      };
    case "InputAddressState":
      return {
        ...state,
        inputAddressState: action.payload,
      };
    case "businessimages":
      return {
        ...state,
        businessImages: action.payload,
      };
    case "UploadCSVFlag":
      return {
        ...state,
        isUploadCSV: action.payload,
      };

    case "base64Images":
      return {
        ...state,
        base64Images: action.payload,
      };
    case "extracomparable":
      return {
        ...state,
        extracomparable: action.payload,
      };
    case "comarablePropertyuuid":
      return {
        ...state,
        comarablePropertyuuid: action.payload,
      };
    case "PDF_COLOR":
      return {
        ...state,
        color: action.payload,
      };
    case "OPTIONS":
      return {
        ...state,
        options: action.payload,
      };
    case "RESET_USER_REDUCER":
      return initialState;
    case "csvType":
      return {
        ...state,
        csvType: action.payload,
      };
    case "REMOVED_COMPARABLE_LIST":
      return {
        ...state,
        removedComparableList: action.payload,
      };
    // new comparable upload
    case "UPLOAD_COMPARABLE_LIST":
      return {
        ...state,
        newComparableUpload: action.payload,
      };

    // case "UPDATE_SOLD_PRICE": {
    //   const { index, newPrice } = action.payload;
    //   const updatedComparables = [...state.comaparables];
    //   // const currentConcession = updatedComparables[index]?.Concession || 0;
    //   updatedComparables[index] = {
    //     ...updatedComparables[index],
    //     added_COMPARABLESLIST: {
    //       ...updatedComparables[index].added_COMPARABLESLIST,
    //       Sold_Price: newPrice,
    //     },
    //   };

    //   updatedComparables[index] = {
    //     ...updatedComparables[index],
    //     ["Net Sales Price"]: newPrice 
    //   }


    //   return {
    //     ...state,
    //     comaparables: updatedComparables,
    //   };
    // }

    // case "UPDATE_CONCESSION": {
    //   const { index, newValue } = action.payload;

    //   // Make a copy of the comaparables array
    //   const updatedComparables = [...state.comaparables];
    //   // const currentSoldPrice = updatedComparables[index]?.added_COMPARABLESLIST?.Sold_Price || 0;

    //   // Update only the Concession field directly
    //   updatedComparables[index] = {
    //     ...updatedComparables[index],
    //     Concession: newValue,
    //   };

    //   // updatedComparables[index] = {
    //   //   ...updatedComparables[index],
    //   //   ["Net Sales Price"]: currentSoldPrice - newValue,
    //   // };

    //   return {
    //     ...state,
    //     comaparables: updatedComparables,
    //   };
    // }

    // case "UPDATE_RANGE": {
    //   const { newStart, newEnd } = action.payload;

    //   return {
    //     ...state,
    //     range: {
    //       // ...state.range,   // keep other keys if any
    //       start: newStart,  // update start
    //       end: newEnd,      // update end
    //     },
    //   };
    // }


    // harsh bhai code 
    // case "UPDATE_SOLD_PRICE": {
    //   // console.log("action.payload in sold price", action.payload);
    //   const { index, newPrice } = action.payload;
    //   const updatedComparables = [...state.comaparables];

    //   const currentConcession = updatedComparables[index]?.Concession || 0;

    //   updatedComparables[index] = {
    //     ...updatedComparables[index],
    //     added_COMPARABLESLIST: {
    //       ...updatedComparables[index].added_COMPARABLESLIST,
    //       Sold_Price: newPrice,
    //     },
    //     ["Net Sales Price"]: newPrice - currentConcession,
    //   };
    //   // console.log("updatedComparables for sold price", updatedComparables);

    //   return {
    //     ...state,
    //     comaparables: updatedComparables,
    //   };
    // }

    // case "UPDATE_CONCESSION": {
    //   // console.log("action.payload in concession", action.payload);
    //   const { index, newValue } = action.payload;
    //   const updatedComparables = [...state.comaparables];

    //   const currentSoldPrice = updatedComparables[index]?.added_COMPARABLESLIST?.Sold_Price || 0;

    //   updatedComparables[index] = {
    //     ...updatedComparables[index],
    //     // Concession: newValue ||0,
    //     Concession: newValue === "" ? "" : newValue,
    //     // ["Net Sales Price"]: currentSoldPrice - newValue,
    //      ["Net Sales Price"]: currentSoldPrice - (newValue === "" ? 0 : newValue),
    //   };
    //   // console.log("updatedComparables for concession", updatedComparables);

    //   return {
    //     ...state,
    //     comaparables: updatedComparables,
    //   };
    // }


    case "UPDATE_SOLD_PRICE": {
      const { uuid, newPrice } = action.payload;

      const updatedComparables = state.comaparables.map(item => {
        // Safe comparison for string/number uuid
        if (item.uuid?.toString() === uuid?.toString()) {
          const currentConcession = item?.Concession || 0;

          console.log("newPricenewPrice", newPrice)
          console.log("currentConcession", currentConcession)
          console.log("currentprice", newPrice - currentConcession)
          return {
            ...item,
            added_COMPARABLESLIST: {
              ...item.added_COMPARABLESLIST,
              Sold_Price: newPrice,
            },
            ["Net Sales Price"]: newPrice - currentConcession,
          };
        }
        return item;
      });
      console.log("updatedComparables after sold price", updatedComparables);


      return {
        ...state,
        comaparables: updatedComparables,
      };
    }

    case "UPDATE_CONCESSION": {
      const { uuid, newValue } = action.payload;

      const updatedComparables = state.comaparables.map(item => {
        // Safe comparison for string/number uuid
        if (item.uuid?.toString() === uuid?.toString()) {
          const currentSoldPrice = item?.added_COMPARABLESLIST?.Sold_Price || 0;
          console.log("newPricenewPrice", newValue)
          console.log("currentConcession", currentSoldPrice)
          console.log("currentprice", currentSoldPrice - newValue)
          return {
            ...item,
            Concession: newValue,
            ["Net Sales Price"]: currentSoldPrice - newValue,
          };
        }
        return item;
      });

      console.log("updatedComparables after concession", updatedComparables);

      return {
        ...state,
        comaparables: updatedComparables,
      };
    }


    // In your reducer
    // case "REMOVE_COMPARABLE": {
    //     console.log("🔴 REMOVE_COMPARABLE - UUID:", action.payload);
    //   console.log("🔴 Before removal:", state.comaparables);
    //   const updatedComparables = state.comaparables.filter(
    //     item => item.uuid !== action.payload
    //   );

    //    console.log("🔴 After removal:", updatedComparables);

    //   return {
    //     ...state,
    //     comaparables: updatedComparables
    //   };
    // }





    case "CSV_UPLOAD_COMPARABLE_LIST":
      return {
        ...state,
        newCSVComparableUpload: action.payload,
      };
    default:
      return state;
  }
};

export default UserReduser;
